<template>
    <div>
        <router-view name="captableModal"></router-view>
        <v-card flat>
            <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>

            <template v-else>
                <v-container>
                    <board-member :client="client" :title="$t('corporate.administration.titleLTDA')" :type="1"></board-member>

                    <template v-if="showBoardSA">
                        <v-divider class="mt-4"></v-divider>

                        <board-member :client="client" :title="$t('corporate.administration.titleSA')" :type="2"></board-member>
                    </template>
                </v-container>
            </template>
        </v-card>
    </div>
</template>

<script>
import API from '@/api'
import BoardMember from '@/components/corporate/BoardMember'

export default {
    name: 'inner-tab-corporate-administration',
    components: {
        BoardMember
    },
    data: function () {
        return {
            loading: true,
            client: {
                name: '',
                optingSimple: false,
                commercialPhone: '',
                stateRegistrationIndicator: '',
                stateRegistration: '',
                municipalRegistration: '',
                city: '',
                cellPhone: '',
                cep: '',
                neighborhood: '',
                totalUsers: undefined,
                isActive: true,
                socialReason: '',
                state: '',
                comments: '',
                address: '',
                country: '',
                addressComplement: '',
                primaryEmail: '',
                type: 'Jurídica',
                addressNumber: '',
                suframaSubscription: '',
                rg: '',
                birthdayFoundationDate: '',
                cpfcnpj: '',
                password: '',
                clientContact: {},
                clientUser: {},
                companyInfo: {}
            }
        }
    },
    watch: {
        '$route': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.loadData()
        window.addEventListener('storageChange', this.onStorageChange)
    },
    beforeDestroy () {
        window.removeEventListener('storageChange', this.onStorageChange)
    },
    computed: {
        showBoardSA () {
            return (this.client.companyInfo.companyType === 1)
        }
    },
    methods: {
        onStorageChange () {
            this.loadData()
        },
        loadData () {
            this.loading = true
            window.getApp.disableClientNavigation = true
            let endpoint = API.EndPoints.getClientCorporateInfo
            let params = {
                objectId: this.$helpers.getCorporateClientId(this.$route.name, 'ClienteSocietarioAdministracao', this.$route.params.id)
            }
            new API(endpoint, params).request().then(response => {
                this.client = Object.assign({}, response.data.result)
                if (!this.client.companyInfo) {
                    this.client.companyInfo = {
                        socialReason: '',
                        companyType: 1,
                        shareCapital: null,
                        socialObjects: '',
                        CNAES: '',
                        headquarters: '',
                        meetingDate: ''
                    }
                }
                this.loading = false
                window.getApp.disableClientNavigation = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        }
    }
}
</script>
